
(function () {
  // This file is also loaded by sections/oja-popup-button.liquid, so this
  // <script> tag can appear more than once on the same page (once per
  // section that includes it). Each occurrence re-runs this whole IIFE, but
  // `initProductPage` below guards itself per-element (see the
  // `data-oja-init` check), so re-running is a cheap no-op for elements
  // already wired up and still correctly wires up any new ones — including
  // a [data-product-page] that didn't exist in the DOM yet the first time
  // this script tag ran (e.g. because it sits further down the page).

  function loadSwiperThen(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var existing = document.querySelector('script[data-oja-swiper]');
    if (existing) {
      if (existing.dataset.ojaSwiperState === 'failed') return;
      existing.addEventListener('load', callback, { once: true });
      return;
    }

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.css';
    link.dataset.ojaSwiperCss = 'true';
    document.head.appendChild(link);

    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11.2.10/swiper-bundle.min.js';
    script.dataset.ojaSwiper = 'true';
    script.dataset.ojaSwiperState = 'loading';
    script.addEventListener(
      'load',
      function () {
        script.dataset.ojaSwiperState = 'loaded';
        if (window.Swiper) callback();
      },
      { once: true }
    );
    script.addEventListener(
      'error',
      function () {
        script.dataset.ojaSwiperState = 'failed';
        console.warn('[OJA] Swiper failed to load; product galleries remain in their static fallback state.');
      },
      { once: true }
    );
    document.body.appendChild(script);
  }

  function initBreadcrumb(root) {
    var breadcrumbLinks = root.querySelectorAll('.oja-breadcrumb a');
    if (breadcrumbLinks.length < 2) return;

    var shopLink = breadcrumbLinks[1];
    shopLink.textContent = 'Shop';
    shopLink.setAttribute('href', '/collections/shop');
  }

  function initAccordion(root) {
    var items = root.querySelectorAll('[data-accordion-group] details');

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  }

  function initIngredientsDrawer(root) {
    var drawer = root.querySelector('[data-ingredients-drawer]');
    var panel = drawer && drawer.querySelector('.ingredients-drawer__panel');
    var openButton = root.querySelector('[data-ingredients-open]');
    var closeButtons = drawer && drawer.querySelectorAll('[data-ingredients-close]');

    if (!drawer || !panel || !openButton || !closeButtons || !closeButtons.length) return;

    var lastFocusedElement = null;

    function openDrawer() {
      lastFocusedElement = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-visible');
      });
      document.body.classList.add('oja-drawer-open');
      openButton.setAttribute('aria-expanded', 'true');
      panel.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-visible');
      document.body.classList.remove('oja-drawer-open');
      openButton.setAttribute('aria-expanded', 'false');

      window.setTimeout(function () {
        drawer.hidden = true;
        if (lastFocusedElement instanceof HTMLElement) {
          lastFocusedElement.focus();
        } else {
          openButton.focus();
        }
      }, 220);
    }

    openButton.addEventListener('click', openDrawer);
    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  function initScentTabs(root) {
    var tabsRoot = root.querySelector('[data-scent-tabs]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-scent-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-scent-panel]'));

    if (!tabsRoot || !tabs.length || !panels.length) return;

    function activateTab(targetKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-scent-tab') === targetKey;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-scent-panel') === targetKey;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-scent-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var delta = event.key === 'ArrowRight' ? 1 : -1;
        var nextIndex = (index + delta + tabs.length) % tabs.length;
        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex].getAttribute('data-scent-tab'));
      });
    });
  }

  function initSwipers(root) {
    var galleryThumbsEl = root.querySelector('[data-gallery-thumbs]');
    var galleryMainEl = root.querySelector('[data-gallery-main]');
    var relatedEl = root.querySelector('[data-related-slider]');
    var reviewsEl = root.querySelector('[data-reviews-slider]');

    if (!galleryThumbsEl && !galleryMainEl && !relatedEl && !reviewsEl) return;

    loadSwiperThen(function () {
      var mainGallery;

      if (galleryThumbsEl && galleryMainEl) {
        var thumbs = new window.Swiper(galleryThumbsEl, {
          direction: 'vertical',
          slidesPerView: 5,
          spaceBetween: 8,
          watchSlidesProgress: true,
          watchOverflow: true,
          breakpoints: {
            0: { direction: 'horizontal', slidesPerView: 5, spaceBetween: 8 },
            821: { direction: 'vertical', slidesPerView: 5, spaceBetween: 8 }
          }
        });

        mainGallery = new window.Swiper(galleryMainEl, {
          slidesPerView: 1,
          speed: 600,
          effect: 'slide',
          thumbs: { swiper: thumbs }
        });

        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));

        function syncDots(activeIndex) {
          dots.forEach(function (dot, index) {
            dot.classList.toggle('is-active', index === activeIndex);
            dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
          });
        }

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = Number(dot.getAttribute('data-gallery-dot'));
            mainGallery.slideTo(index);
          });
        });

        mainGallery.on('slideChange', function () {
          syncDots(mainGallery.realIndex);
        });

        syncDots(0);
      }

      if (relatedEl) {
        new window.Swiper(relatedEl, {
          slidesPerView: 2,
          spaceBetween: 24,
          speed: 700,
          allowTouchMove: true,
          breakpoints: {
            0: { slidesPerView: 2, spaceBetween: 12 },
            821: { slidesPerView: 2, spaceBetween: 28 }
          }
        });
      }

      if (reviewsEl) {
        new window.Swiper(reviewsEl, {
          slidesPerView: 3.15,
          spaceBetween: 8,
          speed: 700,
          breakpoints: {
            0: { slidesPerView: 3.15, spaceBetween: 8 },
            821: { slidesPerView: 4, spaceBetween: 20 }
          }
        });
      }
    });
  }

  // Add-to-cart itself (AJAX submit, cart-drawer auto-open, cart count update)
  // is handled by the theme's own <product-form-component>/<add-to-cart-component>
  // framework (see product-form.js) — the markup in the .liquid file wires into
  // it directly via `ref`/`on:submit`/`on:click` attributes, so no custom fetch
  // logic is needed here. This just keeps the variant <select> (price/label/
  // disabled state) in sync with whichever option is chosen.
  function initVariantSelect(root) {
    var select = root.querySelector('[data-oja-variant-select]');
    if (!select) return;

    var form = select.closest('form');
    var variantIdInput = form ? form.querySelector('[ref="variantId"]') : null;
    var priceEl = root.querySelector('[data-oja-price]');
    var addButton = form ? form.querySelector('[ref="addToCartButton"]') : null;
    var addButtonText = form ? form.querySelector('[data-oja-add-to-cart-text]') : null;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (variantIdInput) variantIdInput.value = option.value;
      if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

      var available = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (addButtonText) addButtonText.textContent = available ? addButtonText.dataset.addLabel || 'Add to bag' : 'Sold out';
    });
  }

  function initProductPage(root) {
    // Per-element guard (not a global/window flag): skips a root that's
    // already wired up, but never skips a root just because *some other*
    // root on the page has already been initialized.
    if (root.dataset.ojaInit === 'true') return;
    root.dataset.ojaInit = 'true';

    initBreadcrumb(root);
    initAccordion(root);
    initIngredientsDrawer(root);
    initScentTabs(root);
    initSwipers(root);
    initVariantSelect(root);
  }

  document.querySelectorAll('[data-product-page]').forEach(initProductPage);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-product-page]');
    if (root) initProductPage(root);
  });
})();

/**
 * OJA Button + Popup section (sections/oja-popup-button.liquid).
 * Merged in from the former assets/oja-popup-button.js. Kept as its own IIFE
 * with its own `initPopup` — a distinct name from every function in the
 * product-page IIFE above — and it only ever queries `.oja-popup-section`,
 * so it can't pick up unrelated markup and doesn't share any state with it.
 * Uses the native <dialog> element (showModal/close), which gives us
 * focus-trapping, Escape-to-close and a backdrop for free.
 */
(function () {
  // Same reasoning as in the IIFE above: this script tag can be present more
  // than once on a page (e.g. product-oja.liquid AND oja-popup-button.liquid
  // both render it). Guard per-element instead of with a global flag, so a
  // popup section that appears later in the DOM than an earlier copy of this
  // script tag still gets wired up.
  function initPopup(root) {
    if (root.dataset.ojaPopupInit === 'true') return;
    root.dataset.ojaPopupInit = 'true';

    var openButton = root.querySelector('[data-oja-popup-open]');
    var dialog = root.querySelector('[data-oja-popup]');
    if (!openButton || !dialog) return;

    if (typeof dialog.showModal !== 'function') {
      // Extremely old browsers without <dialog> support: fall back to just
      // showing it as a plain block so content is never fully unreachable.
      openButton.addEventListener('click', function () {
        dialog.setAttribute('open', 'open');
      });
      return;
    }

    var closeButtons = dialog.querySelectorAll('[data-oja-popup-close]');
    var lastFocusedElement = null;

    function openPopup() {
      lastFocusedElement = document.activeElement;
      dialog.showModal();
      document.body.classList.add('oja-popup-open');
    }

    function closePopup() {
      if (dialog.open) dialog.close();
    }

    openButton.addEventListener('click', openPopup);

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePopup);
    });

    // Click on the backdrop (the ::backdrop pseudo-element isn't clickable
    // directly, so detect clicks that land on the <dialog> itself rather
    // than its panel content).
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closePopup();
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('oja-popup-open');
      if (lastFocusedElement instanceof HTMLElement) {
        lastFocusedElement.focus();
      } else {
        openButton.focus();
      }
    });
  }

  document.querySelectorAll('.oja-popup-section').forEach(initPopup);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.oja-popup-section');
    if (root) initPopup(root);
  });
})();
